var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRegularInboxGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74955 3.23645H18.2494C18.7693 3.23645 19.3366 3.71386 19.4604 4.21912L21.8546 13.9272C21.9505 14.317 22 14.7212 22 15.1223V18.8891C22 19.7727 21.0087 20.7637 20.1247 20.7637H3.87529C2.99128 20.7637 2 19.7727 2 18.8891V15.1223C2 14.7212 2.04951 14.317 2.14544 13.9283L4.53752 4.18406C4.66027 3.68602 5.23689 3.23645 5.74955 3.23645ZM6.25808 5.12549H17.7316L19.774 13.2683H16.2514C15.9491 13.2683 15.6211 13.4859 15.4881 13.7571L14.5009 15.7668H9.41657L8.33658 13.7684C8.19423 13.5065 7.89303 13.2683 7.59389 13.2683H4.1734L6.25808 5.12549ZM3.84641 15.113H7.06267L8.07974 17.1134C8.21899 17.3857 8.54288 17.6125 8.84924 17.6125H15.1281C15.4334 17.6125 15.7501 17.3795 15.8914 17.1093L16.9373 15.113H20.0546V18.4312C20.0546 18.6643 19.7946 18.9282 19.5605 18.9282H4.3436C4.10944 18.9282 3.84641 18.6653 3.84641 18.4312V15.113Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegularInboxGrey);
export default __webpack_public_path__ + "static/media/icon-regular-inbox-grey.c3831f49dc97f0771a293b5089c8e194.svg";
export { ForwardRef as ReactComponent };